module.exports = __webpack_public_path__ + "img/ranking-title.ee18fd6d.png";